const faqItems = [
  {
    q: '玫瑰视频需要付费吗？',
    a: '完全免费！玫瑰视频聚合红桃视频、樱桃视频、茄子视频、糖心视频等平台的高清资源，所有内容均可免费在线观看，无需充值会员，无需订阅付费。我们通过智能内容聚合技术，为用户提供一站式的免费追剧体验。',
  },
  {
    q: '观看视频需要安装播放器或插件吗？',
    a: '不需要。玫瑰视频采用先进的H5播放技术，支持主流浏览器直接播放，包括Chrome、Safari、Edge和手机自带浏览器。无需下载任何播放器、插件或APP即可畅享高清观影体验。',
  },
  {
    q: '为什么有时候视频加载比较慢？',
    a: '视频加载速度受网络环境、同时在线人数和片源服务器影响。我们建议您优先选择WiFi环境观看高清内容，或在设置中切换不同的播放线路以获得最佳体验。玫瑰视频持续优化CDN节点和分流策略，努力减少缓冲情况。',
  },
  {
    q: '更新的剧集多久能同步到玫瑰视频？',
    a: '我们的内容更新团队7×24小时不间断工作。热门剧集通常在上线后2-4小时内完成同步，部分头部内容支持实时更新。您可以在"最新动态"区域查看最近24小时内新增的影视资源列表。',
  },
  {
    q: '玫瑰视频支持哪些设备观看？',
    a: '玫瑰视频完美适配全平台设备：电脑端（Windows/Mac浏览器）、手机端（iOS/Android浏览器）、平板和智能电视投屏。无需额外配置，打开浏览器访问即可获得最佳适配体验。我们还提供了移动端快捷入口，方便您随时随地追剧。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center">
          常见问题
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          关于玫瑰视频，你想知道的都在这里
        </p>

        <div className="mt-8 md:mt-10 max-w-3xl mx-auto space-y-3 md:space-y-4">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/70"
            >
              <h3 className="text-base font-heading font-semibold text-foreground-900 flex items-start gap-3">
                <span className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-xs font-bold flex-shrink-0 mt-0.5">
                  Q
                </span>
                {item.q}
              </h3>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed pl-9">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}